<button type="button" class="btn d-none" data-toggle="modal" [attr.data-target]="'#write-off-modal_' + (key || '')" id="btn-write-off-modal_{{key || ''}}"></button>
<div id="write-off-modal_{{key || ''}}" class="modal fade" tabindex="-1" role="dialog">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-header">
                <h2>Write-Off Sale</h2>
                @if (receivable) {
                    <p class="subtitle">{{receivable.contact}} | {{receivable.vehicle}}</p>
                }
            </div>
            <div class="modal-body">
                <form [formGroup]="form">
                    <div class="form-row form-group">
                        <div class="col-form-label col col-xs-12">
                            <label for="last" class="text-muted">Last Payment</label>
                        </div>
                        <div class="col">
                            @if (receivable && receivable.prevPaymentDate) {
                                <input type="text" readonly class="form-control-plaintext text-muted" id="last" value="{{receivable.prevPaymentDate | date: 'MM/dd/yyyy'}}" />
                            }
                            @else {
                                <input type="text" readonly class="form-control-plaintext text-muted" id="last" value="No payment yet" />
                            }
                        </div>
                    </div>
                    <div class="form-row form-group">
                        <div class="col-form-label col col-xs-12">
                            <label for="when">Date Written-Off</label>
                        </div>
                        <div class="col">
                            <input type="date" class="form-control form-control-sm" id="when" formControlName="when" />
                        </div>
                    </div>
                    <div class="form-row form-group">
                        <div class="col-form-label col col-xs-12">
                            <label for="riding-cash" class="text-muted">Riding Cash</label>
                        </div>
                        <div class="col">
                            @if (receivable) {
                                <input type="text" readonly class="form-control-plaintext text-muted text-right" id="riding-cash" value="{{receivable.ridingCash || 0 | currency}}" />
                            }
                            @else {
                                <input type="text" readonly class="form-control-plaintext text-muted text-right" id="riding-cash" value="{{0 | currency}}" />
                            }
                        </div>
                    </div>
                    <div class="form-row form-group">
                        <div class="col-form-label col col-xs-12">
                            <label for="principal-paid" class="text-muted">Principal Paid</label>
                        </div>
                        <div class="col">
                            @if (receivable) {
                                <input type="text" readonly class="form-control-plaintext text-muted text-right" id="principal-paid" value="{{(receivable.principalPaid || 0) + (receivable.cashDown || 0) | currency}}" />
                            }
                            @else {
                                <input type="text" readonly class="form-control-plaintext text-muted text-right" id="principal-paid" value="{{0 | currency}}" />
                            }
                        </div>
                    </div>
                    <div class="form-row form-group">
                        <div class="col-form-label col col-xs-12">
                            <label for="percent-principal-paid" class="text-muted">Percent Principal Paid</label>
                        </div>
                        <div class="col">
                            @if (receivable) {
                                <input type="text" readonly class="form-control-plaintext text-muted text-right" id="percent-principal-paid" value="{{(receivable.percentPrincipalPaid || 0) / 100 | percent: '1.2-2'}}" />
                            }
                            @else {
                                <input type="text" readonly class="form-control-plaintext text-muted text-right" id="percent-principal-paid" value="{{0 | percent}}" />
                            }
                        </div>
                    </div>
                    <div class="form-row form-group">
                        <div class="col-form-label col col-xs-12">
                            <label for="payoff" class="text-muted">Payoff</label>
                        </div>
                        <div class="col">
                            @if (receivable) {
                                <input type="text" readonly class="form-control-plaintext text-muted text-right" id="payoff" value="{{receivable.payoff || 0 | currency}}" />
                            }
                            @else {
                                <input type="text" readonly class="form-control-plaintext text-muted text-right" id="payoff" value="{{0 | currency}}" />
                            }
                        </div>
                    </div>
                    <ng-container formArrayName="charges">
                        @for (chargeForm of charges.controls; track chargeForm; let i = $index) {
                            <div class="form-row form-group">
                                <div class="col-form-label col col-xs-12">
                                    <label for="amount">Write-Off Charge</label>
                                </div>
                                <div class="col">
                                    <currency-input [control]="charges.controls[i].get('amount')" id="amount"></currency-input>
                                </div>
                            </div>
                        }
                    </ng-container>
                </form>
            </div>
            <div class="modal-footer">
                <button class="btn btn-sm btn-link" data-dismiss="modal"><span class="text-danger">cancel</span></button>
                <button type="button" class="btn btn-sm btn-primary" (click)="writeOff($event)" [disabled]="form.invalid">Write-Off Sale</button>
            </div>
        </div>
    </div>
</div>
